module.exports = __webpack_public_path__ + "static/media/spinner-light.0119fb7e.svg";